// import { isControlIconsEnabled } from "svg-pan-zoom";

// селекторы для создания canvas
const selectors = '[data-avsizes]';
const FPS = 30;
const autoplayWaiting = 10; // секунд до автоплэй

// стили для блоков
var style = document.createElement("style");
style.innerHTML = `
        .vcircular-container {
            min-width: 300px;
            position: relative;
            /* padding: 35px; */
            margin: auto;
            max-width: 95vw;
            max-height: 95vh;
        }

        .vcircular {
            position: relative;
            max-width: 100%;
            height: auto;
            /* width: 90%;
            max-width: 1280px;
            max-height: 720px;
            min-width: 340px; */
        }

        .vcircular-container-listener {
            position: absolute;
            cursor: e-resize;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
        }

        .info-container {
            text-align: center;
            min-width: 300px;
            min-height: 200px;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            display: flex;
            align-content: center;
            justify-content: center;
            flex-direction: column;
            flex-wrap: wrap;
            align-items: center;
            transition: opacity, 0.5s;
        }

        .hidden {
            opacity: 0;
        }

        .removed {
            display: none;
        }

        .imageCemetery{
            position: absolute;
            left:-2000px;
            top:-1000px;
        }
        .logo360{
            position:absolute;
            left:15px;
            bottom:15px;
            width:75px;
            height:auto;

            @media screen and (max-width: 600px) {
                width:35px;
            }
            @media screen and (max-width: 1024px) {
                width:50px;
            }
        }
        `;

function initVcircular() {
    // console.log("initVcircular");
    document.head.appendChild(style);
    // console.log("added styles");
    [...document.querySelectorAll(selectors)].forEach(async (el) => {
        // console.log('element:', el);
        let frames = [],
            touchme = false,
            autoplayback = false,
            autoplaybackTimeout = false,
            previousTouch = false;
        const container = document.createElement("div");
        container.className = "vcircular-container";
        const containerListener = document.createElement("div");
        containerListener.className = "vcircular-container-listener";
        container.appendChild(containerListener);
        const sizes = JSON.parse(el.dataset.avsizes) || [];

        const canvasEl = document.createElement("canvas");
        canvasEl.className = "vcircular";
        canvasEl.width = el.width;
        canvasEl.height = el.height;

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"),
            svgattrs = { "width": "75mm", "height": "65mm", "version": "1.1", "viewBox": "0 0 75 65", "class": "logo360" };
        Object.keys(svgattrs).forEach((key) => {
            svg.setAttribute(key, svgattrs[key])
        })
        svg.innerHTML = '<defs><linearGradient id="grad1" x1="0%" y1="100%" x2="0%" y2="0%"><stop id="first" offset="0%" stop-color="#fff" stop-opacity="1"></stop><stop id="second" offset="1%" stop-color="#fff" stop-opacity="0"></stop></linearGradient></defs><mask id="mask"><rect width="100%" height="100%"fill="url(#grad1)"></rect></mask><g mask="url(#mask)"><g transform="translate(-62 -97)"><path d="m64 129 3.3 0.79q-0.1 0.24-0.1 0.76 0 1.3 0.84 2 0.87 0.73 2.3 0.73 1.5 0 2.3-0.76 0.89-0.76 0.89-2.1 0-1.6-1.3-2.3-1.3-0.73-3.4-0.73v-2.6q1.9 0 2.9-0.68 1-0.71 1-2 0-0.97-0.71-1.5-0.68-0.6-1.9-0.6t-1.9 0.58q-0.73 0.55-0.73 1.5 0 0.52 0.16 0.89l-3.2 0.71q-0.26-0.79-0.26-1.4 0-2.1 1.6-3.6 1.7-1.5 4.4-1.5 2.9 0 4.4 1.2t1.5 3.3q0 1.4-0.76 2.5-0.73 1.1-1.9 1.6 1.6 0.52 2.6 1.7 1 1.2 1 2.9 0 2.7-1.9 4.3-1.9 1.6-4.8 1.6-3.1 0-4.9-1.6-1.7-1.6-1.7-4 0-0.92 0.29-1.6z"/><path d="m91 123-3.2-0.68q0.18-0.39 0.18-0.87 0-0.89-0.68-1.3-0.66-0.47-1.7-0.47-1.8 0-2.9 1.7-1.1 1.7-1.3 4.2 1.8-1.9 4.4-1.9 2.8 0 4.5 1.7 1.8 1.7 1.8 4.4t-1.9 4.5q-1.9 1.8-4.9 1.8-3.3 0-5.2-2.2-1.9-2.3-1.9-6.2 0-3.4 1.1-6 0.92-2.2 2.6-3.4 1.7-1.2 3.9-1.2 2.6 0 4.2 1.3 1.5 1.3 1.5 3.3 0 0.76-0.29 1.5zm-3.4 4.4q-1-0.92-2.5-0.92t-2.5 0.92q-1 0.89-1 2.4t1 2.5q1 0.89 2.5 0.89t2.5-0.89q1-0.92 1-2.5t-1-2.4z"/><path d="m107 120q2.3 2.6 2.3 6.9 0 4.3-2.3 6.9-2.3 2.6-6 2.6-3.6 0-6-2.6-2.3-2.6-2.3-6.9 0-4.3 2.3-6.9 2.3-2.6 6-2.6 3.6 0 6 2.6zm-9.4 12q1.3 1.7 3.5 1.7 2.1 0 3.5-1.7 1.3-1.7 1.3-4.6t-1.3-4.6q-1.3-1.7-3.5-1.7-2.1 0-3.5 1.7-1.3 1.7-1.3 4.6t1.3 4.6z"/><path d="m112 123q-1-1.1-1-2.6t1-2.6q1-1.1 2.6-1.1t2.6 1.1q1 1 1 2.6t-1 2.6q-1 1-2.6 1t-2.6-1zm1.5-3.7q-0.42 0.45-0.42 1.2t0.42 1.2q0.45 0.45 1.2 0.45t1.1-0.45q0.45-0.45 0.45-1.2t-0.45-1.2q-0.42-0.45-1.1-0.45t-1.2 0.45z"/><path d="m85 113h2.9s16-14 27-11c12 4.1 7.5 18 7.5 18l-3.4-1.2 6 13 11-8.5-3.2-1.1s3.8-16-6.9-22c-19-11-41 12-41 12z"/><path d="m70 140h3.8s-4e-3 11 10 12c15 1.9 27-13 27-13h14s-15 23-37 23c-21 0.47-18-22-18-22z"/></g>';
        el.parentNode.appendChild(svg);
        let svgGradFirst = svg.querySelector("#first"),
            svgGradSecond = svg.querySelector("#second");

        container.appendChild(canvasEl);

        const reader = new FileReader();

        const createScreen = function () {
            // console.log("go createScreen");
            let last = frames[0];
            // console.log(last);

            const nextFrame = function (dir = 1) {
                let newFrame = frames.indexOf(last);
                newFrame = dir < 0 ? newFrame - 1 : newFrame + 1;
                newFrame = ((newFrame % frames.length) + frames.length) % frames.length;
                // canvasEl.replaceWith(frames[newFrame]);
                canvasEl.getContext("2d").drawImage(frames[newFrame], 0, 0, canvasEl.width, canvasEl.height);
                // canvasEl.getContext("2d").font = "20pt Arial";
                // canvasEl.getContext("2d").fillText(newFrame, 20, 50);
                last = frames[newFrame];

                // console.log(`frame ${newFrame}, image`, frames[newFrame]);
            };

            // console.log("set nextFrame function");

            const stopAutoanimation = function () {
                // console.log(`stop autoanimation`);
                autoplayback && (autoplayback = clearInterval(autoplayback));
                autoplaybackTimeout && (autoplaybackTimeout = clearTimeout(autoplaybackTimeout));
            };

            // console.log("set stopAutoanimation function");
            // console.log('frames[0]', frames[0]);

            ['mousedown', 'touchstart'].forEach(evt =>
                containerListener.addEventListener(evt, () => { touchme = true; stopAutoanimation(); }, { passive: true })
            );
            ['mousemove', 'touchmove'].forEach(evt =>
                document.body.addEventListener(evt, (e) => {
                    // containerListener.addEventListener(evt, (e) => {
                    // e.preventDefault();
                    // alert("dragging");
                    // console.log("dragging");
                    if (touchme) {
                        // console.log('have touchme');
                        if (e.movementX == undefined) {
                            // console.log('have NOT e.movementX');
                            e.movementX = 1;
                            if (e.touches) {
                                // console.log('have e.touches');
                                let touch = e.touches[0];
                                if (previousTouch) {
                                    // console.log('have previousTouch', previousTouch.pageX, touch.pageX);
                                    e.movementX = touch.pageX - previousTouch.pageX;
                                    // console.log('and now e.movementX = ', e.movementX);
                                };
                                previousTouch = touch;
                            } else {
                                // console.log('have not e.touches');
                            }
                        } else {
                            // console.log('have e.movementX = ', e.movementX);
                        }
                        // console.log("and going to nextFrame with e.movementX = ", e.movementX);
                        nextFrame(e.movementX);
                    } else {
                        // console.log('have NOT touchme');
                    }
                }, { passive: false })
            );
            ['mouseup', 'touchend'].forEach(evt =>
                document.body.addEventListener(evt, () => { touchme = false; autoplaybackTimeout = setTimeout(autoplay, 1000 * autoplayWaiting) }), { passive: true }
            );
            // console.log("listeners initialized");
            const autoplay = () => {
                // console.log(`let autoanimation`);
                // console.log(autoplayback);
                if (!autoplayback) {
                    autoplayback = setInterval(() => {
                        nextFrame(1);
                        // console.log("one tick");
                    }, 1000 / FPS);
                    // console.log(autoplayback);
                }
            }
            el.parentNode.replaceChild(container, el);
            // console.log(`replace image by canvas`);
            // canvasEl.getContext("2d").drawImage(frames[0], 0, 0);
            // console.log(`set canvas to first frame:`, frames[0]);
            nextFrame(1);
            autoplaybackTimeout = setTimeout(autoplay, 1000 * autoplayWaiting);
        }
        reader.onload = async () => {
            // console.log(reader.result);
            const res = reader.result;
            let Imagedata = [];
            // console.log("res.byteLength", res.byteLength);
            // console.log("movie pieces", sizes.length);
            // alert(res.byteLength);
            let startbytes = 0,
                endbytes = 0;

            for (let i = 0; i < sizes.length; i++) {
                // console.log(sizes[i], sizes[i] - 1);
                endbytes = startbytes + sizes[i];

                // console.log(startbytes, endbytes);

                Imagedata = res.slice(startbytes, endbytes);
                startbytes = endbytes;

                let imageBlob = new Blob([Imagedata], { type: "image/jpeg" });
                let img = await createImageBitmap(imageBlob); // https://nxjs.n8.io/runtime/concepts/images
                frames.push(img);
                // console.log(`image ${i}`,Imagedata);

            }
            // console.log(`finish splitting images, get frames array on ${frames.length} pieces`);

            createScreen();
        };

        // считываем файл
        // fetch(el.dataset.pack)
        //     .then(res => res.blob())
        //     .then(blob => reader.readAsArrayBuffer(blob))

        let response = await fetch(el.dataset.pack);
        const packreader = response.body.getReader();
        const contentLength = +response.headers.get('Content-Length');
        let receivedLength = 0; // количество байт, полученных на данный момент
        let chunks = []; // массив полученных двоичных фрагментов (составляющих тело ответа)
        while (true) {
            const { done, value } = await packreader.read();

            if (done) {
                break;
            }
            chunks.push(value);
            receivedLength += value.length;
            let perc = Math.round(receivedLength / contentLength * 100);
            // statusDiv.innerHTML = `Загружено ${perc}%`;
            svgGradFirst.setAttribute("offset", `${perc}%`);
            svgGradSecond.setAttribute("offset", `${perc + 1}%`);

            // console.log(`Получено ${receivedLength} из ${contentLength}`)
        }
        // createScreen();

        let chunksAll = new Uint8Array(receivedLength); // (4.1)
        let position = 0;
        for (let chunk of chunks) {
            chunksAll.set(chunk, position); // (4.2)
            position += chunk.length;
        }


        // console.log(chunksAll);
        reader.readAsArrayBuffer(new Blob([chunksAll], { type: "image/jpeg" }));

        // // Шаг 1: начинаем загрузку fetch, получаем поток для чтения
        // let response = await fetch('https://api.github.com/repos/javascript-tutorial/en.javascript.info/commits?per_page=100');

        // const reader = response.body.getReader();

        // // Шаг 2: получаем длину содержимого ответа
        // const contentLength = +response.headers.get('Content-Length');

        // // Шаг 3: считываем данные:
        // let receivedLength = 0; // количество байт, полученных на данный момент
        // let chunks = []; // массив полученных двоичных фрагментов (составляющих тело ответа)
        // while(true) {
        // const {done, value} = await reader.read();

        // if (done) {
        //     break;
        // }

        // chunks.push(value);
        // receivedLength += value.length;

        // console.log(`Получено ${receivedLength} из ${contentLength}`)
        // }

        // // Шаг 4: соединим фрагменты в общий типизированный массив Uint8Array
        // let chunksAll = new Uint8Array(receivedLength); // (4.1)
        // let position = 0;
        // for(let chunk of chunks) {
        // chunksAll.set(chunk, position); // (4.2)
        // position += chunk.length;
        // }

        // // Шаг 5: декодируем Uint8Array обратно в строку
        // let result = new TextDecoder("utf-8").decode(chunksAll);

        // // Готово!
        // let commits = JSON.parse(result);
        // alert(commits[0].author.login);
        // let blob = new Blob(chunks);


    });
}

export default function () {
    console.log("avvcircular");
    // window.addEventListener('DOMContentLoaded', () => {
    // console.log("DOM loaded");
    setTimeout(initVcircular, 500);
    // });
}